import request from "~/utils/http";
import requestv2 from "~/utils/http-v2";

const saleApi = {
	eventGets : async (params) => {
		const url = 'v2/sale/event';
		return await requestv2.get(url, {params});
	},
	eventAdd : async (params) => {
		const url = 'v2/sale/event';
		return await requestv2.post(url, {
			...params,
			detail: ['user']
		});
	},
	eventUpdate : async (params) => {
		const url = `v2/sale/event/${params.id}`;
		return await requestv2.patch(url, params);
	},
	eventStart : async (params) => {
		const url = `v2/sale/event/start/${params.id}`;
		return await requestv2.post(url, params);
	},
	eventEnd : async (id) => {
		const url = `v2/sale/event/end/${id}`;
		return await requestv2.post(url);
	},
	eventAssign : async (params) => {
		const url = `v2/sale/event/assign/${params.id}`;
		return await requestv2.post(url, params);
	},
	eventReport : async (params) => {
		const url = `v2/sale/event/report/${params.id}`;
		return await requestv2.post(url, params);
	},
	eventDelete : async (id) => {
		const url = `v2/sale/event/${id}`;
		return await requestv2.delete(url);
	},
	eventCancel : async (id) => {
		const url = `v2/sale/event/cancel/${id}`;
		return await requestv2.delete(url);
	},
	workingGets : async (params) => {
		const url = 'v2/sale/working';
		return await requestv2.get(url, {params});
	},
	commitGets : async (params) => {
		const url = 'v2/sale/commit';
		return await requestv2.get(url, {params});
	},
	commitAdd : async (params) => {
		const url = 'v2/sale/commit';
		return await requestv2.post(url, params);
	},
	commitUpdate : async (params) => {
		const url = `v2/sale/commit/${params.id}`;
		return await requestv2.patch(url, params);
	},
	commitConfirm : async (params) => {
		const url = `v2/sale/commit/confirm/${params.id}`;
		return await requestv2.post(url, params);
	},
	commitDelete : async (id) => {
		const url = `v2/sale/commit/${id}`;
		return await requestv2.delete(url);
	},
	kpi : async (params) => {
		const url = 'v2/sale/kpi';
		return await requestv2.get(url, {params});
	},
	addAll : async (params) => {
		const url = 'sales/add-all';
		return await request.post(url, params);
	},
	callSourceGets : async (params) => {
		const url = 'v2/sale/call-source';
		return await requestv2.get(url, {params});
	},
	callSourceAdd : async (params) => {
		const url = 'v2/sale/call-source';
		return await requestv2.post(url, params);
	},
	callSourceDetail : async (id, params) => {
		const url = `v2/sale/call-source/${id}`;
		return await requestv2.get(url, {params});
	},
	callSourceDelete : async (id) => {
		const url = `v2/sale/call-source/${id}`;
		return await requestv2.delete(url);
	},
	callSourceContactCalled : async (id, params) => {
		const url = `v2/sale/call-source/contact/called/${id}`;
		return await requestv2.post(url, params);
	},
	callSourceContactAdd : async (sourceId, params) => {
		const url = `v2/sale/call-source/${sourceId}/contact/add`;
		return await requestv2.post(url, params);
	},
	callSourceContactImport : async (sourceId, contacts) => {
		const url = `v2/sale/call-source/${sourceId}/contact/import`;
		return await requestv2.post(url, { contacts });
	},
	callSourceContactUpdate : async (id, params) => {
		const url = `v2/sale/call-source/contact/${id}`;
		return await requestv2.patch(url, params);
	},
	callSourceContactHistory : async (id) => {
		const url = `v2/sale/call-source/contact/history/${id}`;
		return await requestv2.get(url);
	},
	callSourceContactSetAppointment : async (id) => {
		const url = `v2/sale/call-source/contact/appointment/${id}`;
		return await requestv2.post(url);
	},
	callSourceContactCreate : async (params) => {
		const url = 'v2/sale/call-source/contact/create';
		return await requestv2.post(url, params);
	},
	callSourceTransferUsers : async () => {
		const url = 'v2/sale/call-source/transfer/users';
		return await requestv2.get(url);
	},
	callSourceTransferFromUsers : async () => {
		const url = 'v2/sale/call-source/transfer/from-users';
		return await requestv2.get(url);
	},
	callSourceTransfer : async (params) => {
		const url = 'v2/sale/call-source/transfer';
		return await requestv2.post(url, params);
	},
};

export default saleApi;